import React, { useEffect, useState } from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import Search from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import {
	FormControl,
	InputLabel,
	InputAdornment,
	FilledInput,
} from "@material-ui/core";
import { IconButton } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	search: {
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		"&:hover": {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
	},
	searchIcon: {
		color: "#ffffff",
	},
	inputRoot: {
		color: "white !important;",
		"& input": {
			padding: "8px !important",
			color: "#ffffff",
		},
	},
}));

function TopBarSearchBox(props) {
	const classes = useStyles();
	const [searchInput, setSearchInput] = useState("");

	useEffect(() => {
		if (props.isClose && searchInput) setSearchInput("");
	}, [props.isClose]);

	const handleKepPress = (event) => {
		if (props.callback) {
			props.callback(searchInput || "");
			if (searchInput) {
				props.handleAppSearchByAPI(searchInput, "By Application Id");
			}
		}
	};

	const pathname = window.location.pathname;

	//Hide search bar from home page
	if (pathname != "/") {
		return (
			<FormControl variant="filled" className={classes.search}>
				<FilledInput
					placeholder="Enter Application ID"
					value={searchInput}
					onKeyUp={(event) => {
						if (event.key === "Enter" && searchInput.length >= 3) {
							if (props.callback) {
								props.callback(event.target.value || "");
								if (event.target.value) {
									props.handleAppSearchByAPI(event.target.value, "By Application Id");
								}
							}
						}
					}}
					onChange={(event) => setSearchInput(event.target.value)}
					onBlur={(e)=> setSearchInput(e.target.value?.trim())}
					className={classes.inputRoot}
					endAdornment={
						<InputAdornment position="end">
							<IconButton
								disabled={searchInput.length < 3}
								style={{ display: searchInput.length < 3 ? "none" : "flex" }}
								edge="end"
								onClick={(event) => handleKepPress(event)}>
								<Search className={classes.searchIcon} />
							</IconButton>
						</InputAdornment>
					}
				/>
			</FormControl>
		);
	}
}

export default TopBarSearchBox;
